import { render, staticRenderFns } from "./devTask.vue?vue&type=template&id=ef192844&"
import script from "./devTask.vue?vue&type=script&lang=js&"
export * from "./devTask.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports